
import { Component, PropSync, Prop, Vue } from 'vue-property-decorator';
import QvSelect from '@/components/FormComponents/QvSelect.vue';
import { CommonStore } from '@/store/modules';

@Component({
  components: {
    QvSelect
  }
})
export default class DayOfMonthSelector extends Vue {
  @PropSync('month')
  // eslint-disable-next-line
  syncedMonth!: number;
  @PropSync('day')
  // eslint-disable-next-line
  syncedDay!: number;

  @Prop()
  monthLabel!: string;

  @Prop()
  dayLabel!: string;

  get dateList() {
    return CommonStore.CalendarDayList;
  }

  get months() {
    const months = [];
    for (const monthId of Object.keys(this.dateList)) {
      const monthData = this.dateList[Number(monthId)];
      months.push({
        value: Number(monthId),
        label: monthData.name
      });
    }
    return months;
  }

  get days() {
    const month = this.dateList[this.syncedMonth];
    if (month && month.days) {
      return Array.from({ length: month.days }, (x, i) => i + 1);
    }
    return [];
  }
}
